var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"item"},on:{"dblclick":_vm.open}},[_c('img',{attrs:{"id":"img","src":require(("@/assets/" + _vm.icon)),"width":"49","height":"49","alt":"icon"}}),_c('div',{attrs:{"id":"name"}},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }